import { LegacyCard, Layout, LegacyStack, Text, DescriptionList, Link, Badge } from '@shopify/polaris';

const SellNumbers = ({ sell }) => {
  return <>
    <Layout.Section>
      <LegacyCard>
        <LegacyCard.Section>
          <LegacyStack distribution="fill">
            <span>
              <Text variant="headingXs" weight="semibold">
                Uds.
              </Text>
              <Text variant="heading3xl">{sell.stockQty}</Text>
            </span>
            <span>
              <Text variant="headingXs" weight="semibold">
                Serie-Color
              </Text>
              <Text variant="heading3xl">{sell.distinctProducts}</Text>
            </span>
            <span>
              <Text variant="headingXs" weight="semibold">
                SKU
              </Text>
              <Text variant="heading3xl">{sell.distinctVariants}</Text>
            </span>
            <span>
              <Text variant="headingXs" weight="semibold">
                Valor PVF
              </Text>
              <Text variant="heading3xl">
                {Intl.NumberFormat('es-mx', {
                  style: 'currency',
                  currency: 'MXN',
                }).format(sell.pvfValue ?? 0) + ' '}
                MXN
              </Text>
            </span>
          </LegacyStack>
        </LegacyCard.Section>
        <LegacyCard.Section>
          <LegacyStack distribution="fill">
            <DescriptionList
              items={[
                {
                  term: 'Cliente',
                  description: (
                    <Link
                      url={`/customers/${sell.customer.id}?r=${window.btoa(
                        window.location.pathname + window.location.search,
                      )}`}
                    >
                      {sell.customer.name}
                    </Link>
                  ),
                },
              ]}
            />
            <DescriptionList
              items={[
                {
                  term: 'Depósito',
                  description: (
                    <Link
                      url={`/deposits/${sell.deposit.id}?r=${window.btoa(
                        window.location.pathname + window.location.search,
                      )}`}
                    >
                      {sell.deposit.name}
                    </Link>
                  ),
                },
              ]}
            />{' '}
            <DescriptionList
              items={[
                {
                  term: '',
                  description: (
                    <>
                      {sell.status === 'DRAFT' && (
                        <Badge
                          status={sell.distinctProducts > 0 ? 'attention' : 'new'}
                          progress={sell.distinctProducts > 0 ? 'partiallyComplete' : 'incomplete'}
                        >
                          {sell.distinctProducts > 0 ? 'Borrador' : 'Nuevo'}
                        </Badge>
                      )}
                      {sell.status === 'INVOICED' && (
                        <Badge status="success" progress="complete">
                          Facturado
                        </Badge>
                      )}
                    </>
                  ),
                },
              ]}
            />
          </LegacyStack>
        </LegacyCard.Section>
      </LegacyCard>
    </Layout.Section>
  </>;
};

export default SellNumbers;
